import React from 'react';
import { benefits } from '../../../../constants'; 
import './CareerBenefits.css';
import { useTranslation } from 'react-i18next';

const CareerBenefits = () => {
    
    const { t } = useTranslation();
    
    return (
        <section className='career-benefits'>
            <div className='benefits-container'>

                {/* --- LEWA STRONA (NAPIS) --- */}
                <div className='benefits-left-panel'>
                    <div className='sticky-content'>
                        <h2 className='vertical-title'>Ważne informacje</h2>
                        <p className='vertical-subtitle'>Korzyści współpracy</p>
                    </div>
                </div>

                {/* --- PRAWA STRONA (GRID Z ELEMENTAMI) --- */}
                <div className='benefits-grid'>
                    {benefits.map((benefit) => (
                        <div className="benefit-item" key={benefit.id}>
                            <div className='icon'>{benefit.icon}</div>
                            <div className='text'>
                                <h3>{t(benefit.titleKey)}</h3>
                                <p>{t(benefit.descriptionKey)}</p>
                            </div>
                        </div>
                    ))}
                </div>

            </div>
        </section>
    );
};

export default CareerBenefits;